module.exports = __webpack_public_path__ + "static/media/asset62.3a4eb78f.jpg";